import { render, staticRenderFns } from "./IndicadorVentasMixClientes.vue?vue&type=template&id=09711e53&"
import script from "./IndicadorVentasMixClientes.vue?vue&type=script&lang=js&"
export * from "./IndicadorVentasMixClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports